import m from "mithril";
import { doublefinLogo } from "./SvgImages";

export const LogoSection: m.Component = {
  view() {
    return m("div.pt-5.pb-4", m("div.w-12.h-12.mx-auto", m(doublefinLogo)));
  },
};
